import { render } from "./SingleSymbolSVG.vue?vue&type=template&id=64362a2a"
import script from "./SingleSymbolSVG.vue?vue&type=script&lang=js"
export * from "./SingleSymbolSVG.vue?vue&type=script&lang=js"

import "./SingleSymbolSVG.vue?vue&type=style&index=0&id=64362a2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__